export default __webpack_public_path__ + "static/media/standardTaxationIcon.d67d0ec2.svg";